import { css } from 'styled-components';
import { BreakpointSize, MEDIA_QUERY } from '../breakpoints/breakpoints';
import { SIZES } from '../sizes/sizes';

export interface IGutterAsMarginPropsBase<TAllowedGutter> {
  gutter?: TAllowedGutter;
  gutterTop?: TAllowedGutter;
  gutterRight?: TAllowedGutter;
  gutterBottom?: TAllowedGutter;
  gutterLeft?: TAllowedGutter;
}

export interface IGapPropsBase {
  column?: boolean;
  columnOnMobile?: boolean;
  columnOnTablet?: boolean;
  columnOnSize?: BreakpointSize;
}

export const useFlexDirectionCss = () => css<IGapPropsBase>`
  ${({ columnOnMobile, theme }) =>
    columnOnMobile &&
    css`
      flex-direction: column;
      ${theme.mediaQueries[MEDIA_QUERY.MIN][SIZES.SMALL]} {
        flex-direction: row;
      }
    `};
  ${({ columnOnTablet, theme }) =>
    columnOnTablet &&
    css`
      flex-direction: column;
      ${theme.mediaQueries[MEDIA_QUERY.MIN][SIZES.MEDIUM]} {
        flex-direction: row;
      }
    `};
  ${({ columnOnSize, theme }) =>
    columnOnSize &&
    css`
      flex-direction: column;
      ${theme.mediaQueries[MEDIA_QUERY.MIN][columnOnSize]} {
        flex-direction: row;
      }
    `};
`;
